import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import Header from '../components/header';
import Footer from '../components/footer';

export default function TextImage(props) {
    const [token, setToken] = useState(localStorage.getItem('token') || "");
    let [user, setUser] = useState(null);
    

    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        const storedUser = localStorage.getItem('user');
        
        if (storedToken !== token) {
            setToken(storedToken || "");
        }
        
        if (storedUser) {
            try {
                setUser(user = JSON.parse(storedUser));
            } catch (e) {
                console.error("Failed to parse user data", e);
            }
        }
    }, [token]);

    return (
        <div className="checker-section">
            <Helmet>
                <title>Tool Access | Tooliso</title>
                <meta name="description" content="Access your purchased tools on Tooliso" />
            </Helmet>
            <Header />
            
            <div className="checker-container">
                {token && user ? (
                    <div className="checker-content">
                        <h1 className="checker-title">Welcome, {user.name || user.email}</h1>
                        {user.hasPurchased === false ? (
                            <>
                                <p className="checker-description">Unlock premium tools to boost your productivity</p>
                                <Link to={'/pricing'} className="checker-button">Upgrade Now</Link>
                            </>
                        ) : (
                            <h2>Component</h2>
                        )}
                    </div>
                ) : (
                    <div className="checker-content">
                        <h1 className="checker-title">Access Restricted</h1>
                        <p className="checker-description">Please login to access this premium tool</p>
                        <Link to={'/login'} className="checker-button">Login</Link>
                    </div>
                )}
            </div>
            
            <Footer />
        </div>
    )
}